import React from 'react';
import { X, Mail, RefreshCw } from 'lucide-react';
import { useEmailConfirmationBanner } from '@/hooks/useEmailConfirmationBanner';

export const EmailConfirmationBanner: React.FC = () => {
  const { isVisible, dismissBanner, resendConfirmation, isResending } = useEmailConfirmationBanner();

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-500/90 to-orange-500/90 backdrop-blur-sm">
      <div className="flex items-center justify-between px-4 py-3 text-white">
        <div className="flex items-center gap-3 flex-1">
          <Mail className="h-5 w-5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium">
              Confirmez votre email pour sécuriser votre compte
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2 ml-4">
          <button
            onClick={resendConfirmation}
            disabled={isResending}
            className="flex items-center gap-1 px-3 py-1 text-xs font-medium bg-white/20 hover:bg-white/30 rounded-full transition-colors disabled:opacity-50"
          >
            <RefreshCw className={`h-3 w-3 ${isResending ? 'animate-spin' : ''}`} />
            Renvoyer
          </button>
          
          <button
            onClick={dismissBanner}
            className="p-1 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};